import { initLogger as initGarnishLogger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Declares which extension loggers are enabled for the Order app. Extensions
 * not listed stay silent, and enabled extensions log in production (to
 * Datadog on native, via console collection on web) — add and remove names
 * deliberately.
 *
 * @see libs/garnish/garnish-logger/README.md
 */
export function initLogger() {
  initGarnishLogger({ enabledExtensions: ENABLED_LOG_EXTENSIONS });
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ENABLED_LOG_EXTENSIONS = [
  'AZURE AUTH STATE MACHINE',
  'BRAZE DEEP LINKING',
  'CHECK_IF_ACCESS_TOKEN_HAS_EXPIRED',
  'CUSTOMIZATION',
  'DATE | IGNORE TIMEZONE',
  'DEBUG_MENU',
  'FAVORITES STATE MACHINE',
  'GET_AZURE_AUTH_FRAME_URL',
  'IN_APP_REVIEW',
  'JOIN OR SIGN IN STATE MACHINE',
  'LAUNCH_DARKLY_INTEGRATION',
  'ORDERING_MACHINE',
  'ORDERS HISTORY STATE MACHINE',
  'OTA',
  'OTA UPDATE STATE MACHINE',
  'OTA_MACHINE',
  'RADAR_FOREGROUND_TRACKING',
  'RECEIPT_MACHINE',
  'REMOTE_ASSET_MACHINE',
  'REORDER ORDERS STATE MACHINE',
  'Stripe',
  'Stripe Error',
  'useOpenURL',
  'useRestaurantTippingState',
];
